import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Nav } from "./components/Nav";
import { BrandStrip } from "./components/BrandStrip";
import { Hero } from "./components/Hero";
import { Vision } from "./components/Vision";
import { ProblemSolver } from "./components/ProblemSolver";
import { Vault } from "./components/Vault";
import { Transition } from "./components/Transition";
import { Footer } from "./components/Footer";

const Landing = () => {
  return (
    <main className="relative bg-[#030704] text-white font-body min-h-screen">
      <Nav />
      <BrandStrip />
      <Hero />
      <Vision />
      <ProblemSolver />
      <Vault />
      <Transition />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
